module.exports = __webpack_public_path__ + "img/sticker-square.d6ca9371.svg";